import React from 'react';
import { translate } from 'react-i18next';
import { Tab, Tabs } from 'react-bootstrap';
import ZoneDataTable from '../zone/ZoneDataTable';
import EnvelopDataTable from '../envelop/EnvelopDataTable';
import SectionDataTable from '../section/SectionDataTable';
import FloorDataTable from './FloorDataTable';

export class BuildingLibrary extends React.Component {
  render() {
    const { building, t } = this.props;

    return (
      <Tabs
        id="project-library-tabs"
        onSelect={key => this.setState({ tabActiveKey: key })}
        mountOnEnter={true}
        defaultActiveKey={1}
      >
        <Tab eventKey={4} title={t('floors')}>
          <FloorDataTable
            buildingId={building.id}
            floors={building.floor_list}
          />
        </Tab>
        <Tab eventKey={3} title={t('zones')}>
          <ZoneDataTable building={building} />
        </Tab>
        <Tab eventKey={2} title={t('envelops')}>
          <EnvelopDataTable building={building} />
        </Tab>
        <Tab eventKey={1} title={t('sections')}>
          <SectionDataTable building={building} />
        </Tab>
      </Tabs>
    );
  }
}

export default translate('translations', { withRef: true })(BuildingLibrary);



// WEBPACK FOOTER //
// ./src/components/project_detail/BuildingLibrary.js